<template>
  <div>
    <div
      v-if="loading"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div>
      <canvas
        id="myChartAnaliseComparativoFaturamentoMes"
      />
      <div
        class="text-center px-3"
      >
        <v-row
          align="center"
          class="ma-0 text-center"
        >
          <v-avatar
            class="mr-1"
            color="#4780b8"
            size="12"
          />
          <span class="mr-3 font-weight-light">Faturamento</span>
          <v-avatar
            class="mr-1"
            color="#cadaed"
            size="12"
          />
          <span class="mr-3 font-weight-light">Faturamento Ano Anterior</span>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
  import Produto from '../../../../../services/analiseproduto4'
  import eventEmit from '../../core/EventoEmit'
  import Chart from 'chart.js'

  export default {
    name: 'DashboardTableFaturamentoClassificacaoMes',
    emits: ['setDadosFaturamentoLinha'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      vendedor: [],
      area: [],
      rede: [],
      supervisor: [],
      headers: [],
      faturamento: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      produtos: [],
      cidades: [],
      linhasProducao: [],
      minWidth: 1380,
      width: window.innerWidth,
      enableTable: false,
    }),

    created () {
      eventEmit.$on('set-update-filtros', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-update-filtros', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = select
        this.vendedor = vendedores
        this.area = areas
        this.rede = redes
        this.supervisor = supervisores
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.produtos = produtos
        this.cidades = cidades
        this.linhasProducao = linhasProducao

        this.headers = []
        this.faturamento = []
        this.enableTable = false

        this.showTableFaturamentoClassificacaoMes()
      },

      async showTableFaturamentoClassificacaoMes () {
        this.loading = true

        if (this.chartBarAnaliseComparativoFaturamentoMes) {
          this.chartBarAnaliseComparativoFaturamentoMes.destroy()
        }

        await Produto.showAnaliseCompartivoFaturamentoMes(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.rede, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.produtos, this.cidades, this.linhasProducao).then(resposta => {
          if (resposta.data.status) {
            this.exibirLegenda = true

            const ctx = document.getElementById('myChartAnaliseComparativoFaturamentoMes').getContext('2d')

            const isLargeScreen = window.innerWidth > 1380

            const labelFontSize = isLargeScreen ? 20 : 14

            this.legendaComparativoFaturamentoMes = resposta.data.legenda

            this.chartBarAnaliseComparativoFaturamentoMes = new Chart(ctx, {
              type: 'line',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamento,
                    borderColor: '#4780b8',
                    backgroundColor: 'transparent',
                    order: 2,
                    // tension: 0,
                    tension: 0.2, // Adiciona suavização na linha
                    pointRadius: 5, // Define o tamanho dos pontos nos dados
                    pointBackgroundColor: '#4780b8',
                  },
                  {
                    label: 'Faturamento Anterior',
                    data: resposta.data.faturamentoAnterior,
                    borderColor: '#cadaed',
                    backgroundColor: 'transparent',
                    order: 1,
                    // tension: 0,
                    tension: 0.2, // Adiciona suavização na linha
                    pointRadius: 5, // Define o tamanho dos pontos nos dados
                    pointBackgroundColor: '#4780b8',
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    ticks: {
                      display: true,
                      fontSize: labelFontSize,
                    },
                  }],
                  yAxes: [{
                    gridLines: {
                      display: true,
                      color: '#d3d3d3', // Define a cor das linhas
                      lineWidth: 0.5, // Ajusta a espessura das linhas
                      drawBorder: false, // Remove a borda do eixo Y
                    },
                    display: true,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        return tooltipItem[0].xLabel + ' - ' + resposta.data.ano
                      } else {
                        var ano = resposta.data.ano - 1
                        return tooltipItem[0].xLabel + ' - ' + ano
                      }
                    },
                  },
                  titleFontSize: 16,
                  bodyFontSize: 16,
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            if (this.chartBarAnaliseComparativoFaturamentoMes.data) {
              this.chartBarAnaliseComparativoFaturamentoMes.destroy()
            }

            this.title = false

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.chartBarAnaliseComparativoFaturamentoMes.data) {
              this.chartBarAnaliseComparativoFaturamentoMes.destroy()
            }

            this.title = false

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
            if (this.chartBarAnaliseComparativoFaturamentoMes.data) {
              this.chartBarAnaliseComparativoFaturamentoMes.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loading = false })
      },

      formatCurrency (value) {
        // Função para formatar um valor numérico para moeda brasileira
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #tableFatClassificacaoMes {
      width: 100% !important;
    }

    #idTable {
      max-height: 500px;
      max-width: 360px !important;
      margin: 0 0 0 0rem;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  @media screen
  and (min-width: 1380px) {
    #myChartAnaliseComparativoFaturamentoMes {
      height: 700px !important;
      width: 1300px !important;
      margin: 0 0 0 10rem;
    }
  }
</style>

<style lang="sass">
  #textoKgFaturado
    margin: -1.3rem 0 0 4rem

  .large-screen .v-data-table
    height: 500px

  #myChartAnaliseComparativoFaturamentoMes
    width: 1000px !important
    height: 500px !important
    margin: 0 0 0 7rem
</style>
